import { FileWithPreview } from 'react-dropzone';

export const UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO = 'UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO';
export type UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO = typeof UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO;

export interface UploadImagesInImportWizardInfo {
    type: UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO;
    filesToUpload: FileWithPreview[];
}

export function uploadImagesInImportWizardInfoAction(files: FileWithPreview[]): UploadImagesInImportWizardInfo {
    return {
        type: UPLOAD_IMAGES_IN_IMPORT_WIZARD_INFO,
        filesToUpload: files
    };
}
